import { useEffect } from 'react';

const RAZORPAY_SCRIPT_ID = 'razorpay-checkout-script';
const RAZORPAY_SCRIPT_URL = 'https://checkout.razorpay.com/v1/checkout.js';

const useRazorpay = () => {
  useEffect(() => {
    if (window.Razorpay) return;

    const existingScript = document.getElementById(RAZORPAY_SCRIPT_ID);
    if (existingScript) return;

    const script = document.createElement('script');
    script.id = RAZORPAY_SCRIPT_ID;
    script.src = RAZORPAY_SCRIPT_URL;
    script.async = true;
    script.onerror = () => {
      console.error('Failed to load Razorpay checkout script');
    };
    document.body.appendChild(script);
  }, []);
};

export default useRazorpay;
